import * as ebsRequestRecordLog from "./ebsRequestRecordLog";
import * as exchange from "./exchange";
import * as exchangeFacadeImpl from "./exchangeFacadeImpl";
import * as openApiConfig from "./openApiConfig";
import * as requestRecordLog from "./requestRecordLog";
import * as systemConfig from "./systemConfig";
import * as tripartiteSystemAuth from "./tripartiteSystemAuth";

export const bus = {
  ebsRequestRecordLog,
  exchange,
  exchangeFacadeImpl,
  openApiConfig,
  requestRecordLog,
  systemConfig,
  tripartiteSystemAuth,
};
